import { useDeleteFilter } from '~/core/shared/api/middle-office/filters';
import { useTenantedApplicationConfig } from '~/core/shared/contexts';
import { useDefinition } from '../../contexts';
import { buildDefinitionParams } from '../logic/buildDefinitionParams';

export const useDeleteFilterQuery = (onSuccess: () => void) => {
  const config = useTenantedApplicationConfig();
  const { definition } = useDefinition();
  return useDeleteFilter(buildDefinitionParams(definition, config), {
    onSuccess,
  });
};
